import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { IntercomService } from '@principle-theorem/ng-intercom';
import { UsersModule } from '@principle-theorem/ng-principle';
import {
  InformationBoxComponent,
  PartnerService,
} from '@principle-theorem/ng-principle-shared';
import { BreadcrumbsStore } from '@principle-theorem/ng-shared';
import { Partner } from '@principle-theorem/principle-core';
import {
  IUser,
  PartnerStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  CollectionReference,
  filterUndefined,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AppListComponent } from '../app-list/app-list.component';
import { TestAccountListComponent } from '../test-account-list/test-account-list.component';

@Component({
  selector: 'pr-partner-view',
  imports: [
    CommonModule,
    AppListComponent,
    TestAccountListComponent,
    InformationBoxComponent,
    UsersModule,
    MatButtonModule,
  ],
  templateUrl: './partner-view.component.html',
  styleUrl: './partner-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnerViewComponent {
  userCollection$: Observable<CollectionReference<IUser>>;
  isLive$: Observable<boolean>;
  isProduction = environment.production;

  constructor(
    partnerService: PartnerService,
    breadcrumbs: BreadcrumbsStore,
    public intercom: IntercomService
  ) {
    const partner$ = partnerService.partner$.pipe(filterUndefined());

    partner$.pipe(take(1), takeUntilDestroyed()).subscribe((partner) => {
      breadcrumbs.setBreadcrumbs([
        {
          label: partner.name,
        },
      ]);
    });

    this.userCollection$ = partner$.pipe(
      map((partner) => Partner.userCol(partner))
    );

    this.isLive$ = partner$.pipe(
      map((partner) => partner.status === PartnerStatus.Live)
    );
  }
}
